import { Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";

@Component({
	selector: "app-opciones-adicionales-dte",
	templateUrl: "./opciones-adicionales-dte.component.html",
	styleUrls: ["./opciones-adicionales-dte.component.scss"],
})
export class OpcionesAdicionalesDteComponent {
	@Input() showCredEC: boolean = false;
	@Input() showIvaTerceros: boolean = false;
	@Input() showMonedaButton: boolean = false;
	@Input() tipoPago: string = "";
	@Input() credECTemplate: TemplateRef<any>;
	@Input() ivaTercerosTemplate: TemplateRef<any>;
	@Output() monedaClick = new EventEmitter<void>();
	@Output() tipoPagoChange = new EventEmitter<string>();
}
